(() => {
  const formatMoney = (cents, currency) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  };

  const initMenu = () => {
    const toggle = document.querySelector('[data-menu-toggle]');
    const menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    const setOpen = (open) => {
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      menu.classList.toggle('is-open', open);
      menu.hidden = !open;
      document.body.classList.toggle('menu-open', open);
    };

    toggle.addEventListener('click', () => {
      setOpen(toggle.getAttribute('aria-expanded') !== 'true');
    });

    menu.addEventListener('click', (event) => {
      if (event.target.closest('a')) setOpen(false);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') setOpen(false);
    });
  };

  const initSortForms = () => {
    document.querySelectorAll('[data-sort-select]').forEach((select) => {
      select.addEventListener('change', () => select.form.submit());
    });
  };

  const initProductForms = () => {
    document.querySelectorAll('[data-product-root]').forEach((root) => {
      const jsonElement = root.querySelector('[data-product-json]');
      const idInput = root.querySelector('[data-variant-id]');
      const addButton = root.querySelector('[data-add-to-cart]');
      const addButtonText = root.querySelector('[data-add-to-cart-text]');
      const price = root.querySelector('[data-product-price]');
      const comparePrice = root.querySelector('[data-compare-price]');

      if (!jsonElement || !idInput || !addButton) return;

      let variants = [];
      try {
        variants = JSON.parse(jsonElement.textContent);
      } catch (error) {
        return;
      }

      const getSelectedOptions = () => {
        const values = [];
        root.querySelectorAll('[data-option-index]').forEach((group) => {
          const checked = group.querySelector('input:checked');
          if (checked) values[Number(group.dataset.optionIndex)] = checked.value;
        });
        return values;
      };

      const updateVariant = () => {
        const selected = getSelectedOptions();
        const variant = variants.find((item) => item.options.every((option, index) => option === selected[index]));

        if (!variant) {
          addButton.disabled = true;
          if (addButtonText) addButtonText.textContent = root.dataset.unavailableLabel;
          return;
        }

        idInput.value = variant.id;
        addButton.disabled = !variant.available;
        if (addButtonText) {
          addButtonText.textContent = variant.available ? root.dataset.addLabel : root.dataset.soldOutLabel;
        }

        if (price) price.textContent = formatMoney(variant.price, root.dataset.currency);
        if (comparePrice) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePrice.textContent = formatMoney(variant.compare_at_price, root.dataset.currency);
            comparePrice.hidden = false;
          } else {
            comparePrice.hidden = true;
          }
        }

        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      root.querySelectorAll('[data-option-index] input').forEach((input) => {
        input.addEventListener('change', updateVariant);
      });
    });
  };

  const initModelViewers = () => {
    document.querySelectorAll('model-viewer').forEach((viewer) => {
      if (viewer.loaded) {
        viewer.classList.add('is-loaded');
      } else {
        viewer.addEventListener('load', () => viewer.classList.add('is-loaded'), { once: true });
      }
      viewer.addEventListener('contextmenu', (event) => event.preventDefault());
    });
  };

  const initScrollReveal = (scope = document) => {
    const selector = [
      '.section-shell',
      '.product-card',
      '.footer-script-mark',
      '.footer-lead > *',
      '.footer-utility > *',
      '.footer-meta'
    ].join(',');
    const elements = Array.from(scope.querySelectorAll(selector)).filter((element) => !element.dataset.revealBound);

    if (!elements.length) return;

    document.documentElement.classList.add('reveal-ready');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => {
        element.dataset.revealBound = 'true';
        element.classList.add('reveal-on-scroll', 'is-visible');
      });
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.08,
      rootMargin: '0px 0px -5% 0px'
    });

    elements.forEach((element, index) => {
      element.dataset.revealBound = 'true';
      element.style.setProperty('--reveal-delay', `${Math.min((index % 6) * 55, 275)}ms`);
      element.classList.add('reveal-on-scroll');
      observer.observe(element);
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    initMenu();
    initSortForms();
    initProductForms();
    initModelViewers();
    initScrollReveal();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initModelViewers();
    initScrollReveal(event.target);
  });
})();
